<div class="product-id" *ngIf="visible$ | async">
  <span class="product-id-label">{{ 'product.sku.label' | translate }}</span>
  <span itemprop="sku">{{ sku$ | async }}</span>
</div>
